import { HttpErrorResponse } from '@angular/common/http';
import { Observable, retry, tap, throwError, timer } from 'rxjs';

interface RetryOptions {
  count?: number;
  retryDelayBase?: number;
  logicToRunOnError?: (error: HttpErrorResponse, retryIndex: number) => void;
  conditionToRetryRequest?: (error: HttpErrorResponse) => boolean;
  numberOfSecondsBeforeSlowMessage?: number;
  slowMessageHandler?: () => void;
}

export function setupErrorRetryLogic<T = any>(methodToRetry: Observable<T>, options: RetryOptions = {}): Observable<T> {
  const {
    count = 2,
    retryDelayBase = 100,
    logicToRunOnError,
    conditionToRetryRequest,
    numberOfSecondsBeforeSlowMessage = 3,
    slowMessageHandler,
  } = options;

  const slowRequestTimer = setTimeout(() => {
    slowMessageHandler?.();
  }, numberOfSecondsBeforeSlowMessage * 1000);

  return methodToRetry.pipe(
    tap(() => clearTimeout(slowRequestTimer)),
    retry({
      count,
      delay: (error, retryIndex) => {
        console.warn(`Retrying request... attempt #${retryIndex}`);
        logicToRunOnError?.(error, retryIndex);

        if (conditionToRetryRequest && !conditionToRetryRequest(error)) {
          return throwError(() => error);
        }

        const delayTime = Math.pow(2, retryIndex - 1) * retryDelayBase;
        return timer(delayTime);
      },
    })
  );
}
